export const productImagePlaceholder = `data:image/png;base64,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`

export const removePriceDecimal = (priceString) => {
    return priceString.replace(/([.,]00)\s*$/, '');
}

export const addToCart = async (id, isPreorder) => {
    try {
        if(typeof id === 'string' && window.rfd) {
            const body = { id, quantity: 1 };
            if(isPreorder) {
                body.properties = { 'Pre-Order Item': 'This is a Preorder item' }
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(body)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            window.rfd?.renderCart(false, window.rfd?.enableBtns);
            return data;
        }
    } catch (error) {
        console.warn("[Nosto serp] Error adding product to cart", error)
    }
}

export async function fetchVideo(videoGid) {
    const endpoint = 'https://cultgaia.myshopify.com/api/2025-10/graphql.json';
    const query = `
        query getVideo($id: ID!) {
            node(id: $id) {
                ... on Video {
                    id
                    alt
                    sources {
                        url
                        format
                        height
                        width
                    }
                }
            }
        }
    `;

    try {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "e8ea5d7478a9813874919abbf781c140",
            },
            body: JSON.stringify({ query, variables: { id: videoGid } }),
        });

        if(!response.ok) {
            throw new Error(`Shopify API returned ${response.status}`)
        }
        const result = await response.json();
        if(result.errors) {
           throw new Error("GraphQL errors:", result.errors);
        }
        return result.data?.node || null;
    } catch (error) {
        console.warn(`[Nosto serp] (${videoGid}) Failed to fetch video details`, error);
        return null;
    }
}

/**
 * Sorts an array, generally used to order size filters.
 * 
 * @param {(string | object)[]} data - An array of strings or objects. Usually is `facet.data`
 * @param {string[]} orderedData - An array of strings. The order will determine how `data` is returned.
 * @param {(item: string) => string | undefined} [getValue] - Optional function that will be called on each data to extract value, if data isn't a string.
 * @returns {string[]} - returns a copy array of `data`, ordered according to `orderedData`
 */
export const sortData = (data, orderedData, getValue) => {
    if(!data?.length) return [];
    if(data.length === 1) return data;
    
    const hasGetValue = getValue && typeof getValue === 'function';
    const orderMap = new Map(orderedData.map((val, i) => [val, i])); // for speed

    return [...data].sort((a, b) => {
        const valA = hasGetValue ? getValue(a) : a;
        const valB = hasGetValue ? getValue(b) : b;
        const indexA = orderMap.get(valA) ?? Infinity;
        const indexB = orderMap.get(valB) ?? Infinity;
        return indexA - indexB;
    });
};

/**
 * Function that returns Shopify CDN image URL cropped based on size.
 * @param {string} src - Image URL
 * @param {number | string} size - Image width
 * @returns {string}
 */
export function getSrc(src, size) {
    return src.replace('.jpg', `_${size}x.jpg`).replace('.png', `_${size}x.png`).replace('.webp', `_${size}x.webp`).replace('.gif', `_${size}x.gif`)
}

/**
 * Function that returns Shopify CDN image URL full srcset.
 * @param {string} src - Image URL
 * @param {(number | string)[]} sizes - Widths for the srcset
 * @returns {string}
 */
export function getSrcset(src, sizes) {
    if(typeof src !== 'string') {
        console.warn("[Nosto SERP] Unable to get image srcset, using fallback.")
        return productImagePlaceholder;
    };
    return sizes.map(size => `${getSrc(src, size)} ${size}w`).join(', ')
}

export async function fetchFullFacet(facetId) {
    if(!facetId) return null;
    
    const categoryId = "278844637258"; // collections/all, make sure all values are fetched
    
    try {
        const jsonQuery = JSON.stringify({ query: 
            `query {
                search(
                    accountId: "shopify-3367793"
                    products: {
                        categoryId: "${categoryId}"
                        facets: ["${facetId}"]
                        size: 0
                    }
                ) {
                    products {
                        facets {
                            ... on SearchTermsFacet {
                                id
                                field
                                data {
                                    value
                                }
                            }
                        }
                    }
                }
            }`
        });

        const configs = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: jsonQuery,
        };

        const response = await fetch("https://search.nosto.com/v1/graphql", configs)
        const data = await response.json();
        if(data?.data?.errors?.length > 0) throw new Error("Error fetching full facet data", data.errors.map(e => e.message).join(", "))
        return data?.data?.search?.products?.facets?.find(facet => facet.id === facetId) || null;
    } catch (error) {
        console.warn("[SERP] Failed to get search product total", error);
        return null;
    }
}

/**
 * Maps full facet data into a hierarchical structure
 * @param {Object} fullFacetData - The full facet data from fetchFullFacet
 * @param {string} separator - The separator used to split category levels (e.g., ">")
 * @returns {Array} Hierarchical array of categories with nested children
 */
export function mapFacetHierarchy(fullFacetData, separator) {
    if (!fullFacetData?.data || !separator) return [];
    
    const hierarchyMap = {};

    fullFacetData.data.forEach(item => {
        const parts = item.value.split(separator);
        let currentLevel = hierarchyMap;
        
        parts.forEach((part, index) => {
            const trimmedPart = part.trim();
            if (!currentLevel[trimmedPart]) {
                currentLevel[trimmedPart] = {
                    level: index,
                    value: trimmedPart,
                    children: {}
                };
            }
            currentLevel = currentLevel[trimmedPart].children;
        });
    });

    const convertToArray = (obj, level = 0) => {
        return Object.values(obj).map(item => {
            const hasChildren = Object.keys(item.children).length > 0;
            const result = {
                level: item.level,
                value: item.value
            };
            
            if (hasChildren) {
                result.children = convertToArray(item.children, level + 1);
            }
            
            return result;
        });
    };

    return convertToArray(hierarchyMap);
}

/**
 * Recursively collects all descendant values from a hierarchical node
 * @param {Object} node - The hierarchical node with potential children
 * @returns {Array} Array of all descendant values at all levels
 */
export function getAllDescendantValues(node) {
    const values = [];
    if (node.children && node.children.length > 0) {
        node.children.forEach(child => {
            values.push(child.value);
            if (child.children && child.children.length > 0) {
                values.push(...getAllDescendantValues(child));
            }
        });
    }
    return values;
}

/**
 * Optimized function to get all values from current branch (including all descendants)
 * Uses iterative approach with stack for better performance on deep hierarchies
 * @param {Object} node - The hierarchical node
 * @returns {Array} Array of all values in the branch
 */
export function getBranchValues(node) {
    const values = [node.value];
    const stack = node.children ? [...node.children] : [];
    
    while (stack.length > 0) {
        const current = stack.pop();
        values.push(current.value);
        if (current.children) {
            stack.push(...current.children);
        }
    }
    
    return values;
}

/**
 * Efficiently filters values that are outside the current branch
 * Uses Set for O(1) lookup performance
 * @param {Array} currentValues - Current filter values
 * @param {Array} branchValues - Values in the current branch
 * @returns {Array} Values outside the branch
 */
export function getValuesOutsideBranch(currentValues, branchValues) {
    const branchSet = new Set(branchValues);
    return currentValues.filter(value => !branchSet.has(value));
}

/**
 * Optimized function to find an item in hierarchy by value
 * Uses breadth-first search for better average performance
 * @param {Array} hierarchy - The hierarchy array to search
 * @param {string} targetValue - The value to find
 * @returns {Object|null} The found item or null
 */
export function findItemInHierarchy(hierarchy, targetValue) {
    const queue = [...hierarchy];
    
    while (queue.length > 0) {
        const current = queue.shift();
        if (current.value === targetValue) {
            return current;
        }
        if (current.children) {
            queue.push(...current.children);
        }
    }
    
    return null;
}

/**
 * Optimized function to check if all siblings are selected
 * Pre-filters siblings by facet data existence and uses Set for O(1) lookups
 * @param {Object} parentItem - The parent item containing children
 * @param {Object} currentFilter - The filter being toggled
 * @param {Array} currentValues - Current filter values
 * @param {Array} facetData - The facet data to validate against
 * @returns {boolean} True if all existing siblings are selected
 */
export function areAllSiblingsSelected(parentItem, currentFilter, currentValues, facetData) {
    if (!parentItem.children) return false;
    
    // Create a Set for O(1) facet existence lookup
    const facetValueSet = new Set(facetData.map(item => item.value));
    
    // Pre-filter siblings that exist in facet data
    const existingSiblings = parentItem.children.filter(sibling => 
        facetValueSet.has(sibling.value)
    );
    
    // Create a Set for O(1) current values lookup
    const currentValuesSet = new Set(currentValues);
    
    return existingSiblings.every(sibling => {
        if (sibling.value === currentFilter.value) {
            return !currentFilter.selected; // Will be selected after toggle
        }
        const siblingFilter = facetData.find(f => f.value === sibling.value);
        return siblingFilter && (currentValuesSet.has(sibling.value) || siblingFilter.selected);
    });
}

/**
 * Optimized function to get sibling values that exist in facet data
 * Uses Set for O(1) facet existence lookup and filters efficiently
 * @param {Object} parentItem - The parent item containing children
 * @param {string} excludeValue - Value to exclude from siblings
 * @param {Array} facetData - The facet data to validate against
 * @returns {Array} Array of sibling values that exist in facet data
 */
export function getExistingSiblingValues(parentItem, excludeValue, facetData) {
    if (!parentItem.children) return [];
    
    // Create a Set for O(1) facet existence lookup
    const facetValueSet = new Set(facetData.map(item => item.value));
    
    return parentItem.children
        .filter(sibling => sibling.value !== excludeValue && facetValueSet.has(sibling.value))
        .map(sibling => sibling.value);
}

/**
 * Optimized function to get child values that exist in facet data
 * Uses Set for O(1) facet existence lookup
 * @param {Object} parentItem - The parent item containing children
 * @param {Array} facetData - The facet data to validate against
 * @returns {Array} Array of child values that exist in facet data
 */
export function getExistingChildValues(parentItem, facetData) {
    if (!parentItem.children) return [];
    
    const facetValueSet = new Set(facetData.map(item => item.value));
    
    return parentItem.children
        .map(child => child.value)
        .filter(childValue => facetValueSet.has(childValue));
}

/**
 * Optimized function to find the parent of a specific item in hierarchy
 * Uses breadth-first search for better average performance
 * @param {Object} rootItem - The root item to search from
 * @param {string} targetValue - The value to find the parent of
 * @returns {Object|null} The parent item or null if not found
 */
export function findParentOfItem(rootItem, targetValue) {
    if (rootItem.children) {
        const isDirectChild = rootItem.children.some(child => child.value === targetValue);
        if (isDirectChild) {
            return rootItem;
        }
        
        for (const child of rootItem.children) {
            const parent = findParentOfItem(child, targetValue);
            if (parent) return parent;
        }
    }
    
    return null;
}

/**
 * Recursively consolidate parents when all siblings are selected
 * @param {Object} parentItem - The parent item whose siblings to check
 * @param {Array} currentValues - Current filter values
 * @param {Array} mappedData - The hierarchical data structure
 * @param {Array} facetData - The facet data to validate against
 * @returns {Array} Updated values with consolidated parents
 */
export function consolidateParentsRecursively(parentItem, currentValues, mappedData, facetData) {
    let grandParent = null;
    for (const rootItem of mappedData) {
        grandParent = findParentOfItem(rootItem, parentItem.value);
        if (grandParent) break;
    }
    
    if (!grandParent) return currentValues;
    
    const allParentSiblings = getExistingSiblingValues(grandParent, '', facetData);
    allParentSiblings.push(parentItem.value);
    
    const allParentSiblingsSelected = allParentSiblings.every(siblingValue => 
        currentValues.includes(siblingValue)
    );
    
    if (allParentSiblingsSelected) {
        const updatedValues = currentValues.filter(v => !allParentSiblings.includes(v));
        updatedValues.push(grandParent.value);
        return consolidateParentsRecursively(grandParent, updatedValues, mappedData, facetData);
    }
    
    return currentValues;
}

/**
 * Helper function to preserve sibling branch values at all levels
 * This handles the complex logic for mixed leaf/parent sibling scenarios
 * @param {Object} currentItem - The item being clicked
 * @param {Array} mappedData - The hierarchical data structure
 * @param {Array} currentValues - Current filter values
 * @returns {Array} Values to preserve from sibling branches
 */
export function preserveSiblingBranchesAtAllLevels(currentItem, mappedData, currentValues) {
    const siblingBranchValues = [];
    
    for (const rootItem of mappedData) {
        const parent = findParentOfItem(rootItem, currentItem.value);
        if (parent && parent.children) {
            // For each sibling of current item, collect values that are currently selected within their branches
            parent.children.forEach(sibling => {
                if (sibling.value !== currentItem.value) {
                    const siblingBranch = getBranchValues(sibling);
                    const selectedInSiblingBranch = siblingBranch.filter(value => currentValues.includes(value));
                    siblingBranchValues.push(...selectedInSiblingBranch);
                }
            });
            
            // Recursively go up the hierarchy to preserve siblings at higher levels
            if (parent.value !== currentItem.value) {
                const parentSiblingValues = preserveSiblingBranchesAtAllLevels(parent, mappedData, currentValues);
                siblingBranchValues.push(...parentSiblingValues);
            }
        }
        break;
    }
    
    return siblingBranchValues;
}

/**
 * Helper function to handle parent filter deselection logic
 * Manages the complex logic when ancestors are selected and need to be expanded
 * @param {Object} item - The item being clicked
 * @param {Array} parentFilters - Array of parent filters in hierarchy
 * @param {Array} mappedData - The hierarchical data structure
 * @param {Array} splitNestedFacetData - The facet data
 * @returns {Array} Updated values after deselection
 */
export function handleParentDeselection(item, parentFilters, mappedData, splitNestedFacetData) {
    let updatedValues = [];
    
    // Find the highest selected ancestor and work down to find the correct level to expand
    let selectedAncestor = null;
    let selectedAncestorLevel = -1;
    
    // Find the highest level selected parent
    for (let i = parentFilters.length - 1; i >= 0; i--) {
        if (parentFilters[i]?.selected) {
            selectedAncestor = parentFilters[i];
            selectedAncestorLevel = i;
            break;
        }
    }
    
    if (selectedAncestor) {
        // Find what level the current item is relative to the selected ancestor
        const selectedAncestorFromHierarchy = findItemInHierarchy(mappedData, selectedAncestor.value);
        
        if (selectedAncestorFromHierarchy) {
            // Walk down the hierarchy to find the appropriate level to expand
            let currentLevelParent = selectedAncestorFromHierarchy;
            let targetLevel = parentFilters.length - selectedAncestorLevel - 1;
            
            // Navigate to the correct level
            for (let level = 0; level < targetLevel && currentLevelParent; level++) {
                if (currentLevelParent.children) {
                    // Find the child that contains our target item
                    currentLevelParent = currentLevelParent.children.find(child => {
                        // Check if this child's branch contains our target item
                        const childBranchValues = getBranchValues(child);
                        return childBranchValues.includes(item.value);
                    });
                }
            }
            
            if (currentLevelParent && currentLevelParent.children) {
                // Add all siblings at this level EXCEPT the one containing our target item
                const siblingsExceptTarget = currentLevelParent.children
                    .filter(child => {
                        const childBranchValues = getBranchValues(child);
                        return !childBranchValues.includes(item.value);
                    })
                    .map(child => child.value)
                    .filter(value => splitNestedFacetData.some(f => f.value === value));
                
                updatedValues.push(...siblingsExceptTarget);
            }
        }
    }
    
    return updatedValues;
}